import {observable} from "mobx";
import api from "./SlideShop.API";

class SlideShopStore {
  @observable listRating = [];

  getList = async () => {
    const res = await api.list();
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  create = async (data) => {
    const res = await api.create(data);
    if (!!res.validateError) {
      return {error: res.validateError};
    }
    return await res.json();
  };

  update = async (data) => {
    const res = await api.update(data);
    if (!!res.validateError) {
      return {error: res.validateError};
    }
    return await res.json();
  };

  delete = async (data) => {
    const res = await api.delete(data);
    if (!!res.validateError) {
      return {error: res.validateError};
    }
    return await res.json();
  };
}

const slideShopStore = new SlideShopStore();
export default slideShopStore;



// WEBPACK FOOTER //
// ./src/services/slideShop/SlideShop.Store.js